module.exports = __webpack_public_path__ + "static/samuel-s-daggett-mobile.3a588b9b.webp";